function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDF6A",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "index-desktop-copy-6",
  transform: "translate(-796.000000, -806.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-2",
  transform: "translate(797.000000, 806.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Watch_2218663",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.7705868,7.56090347e-15 L5.18206579,7.56090347e-15 C4.77253504,7.56090347e-15 4.44054477,0.330160349 4.44054477,0.737433779 L4.44054477,12.1884087 C1.64593683,14.4347937 0.0154283319,17.8120145 0.00010592032,21.3855271 C-0.0150016408,24.9590397 1.58669044,28.349871 4.3620696,30.6197106 L4.523825,42.1878343 C4.52944518,42.5911335 4.85977259,42.9151874 5.26534602,42.9151874 L5.27584596,42.9151874 L18.8629136,42.7239855 C19.2723181,42.7182584 19.5995723,42.3836205 19.5939347,41.976471 L19.4367323,30.7342931 C22.2765035,28.4908771 23.9378053,25.0860612 23.9525661,21.4793524 C23.9671313,17.8726437 22.3335677,14.4545799 19.5121301,12.1884014 L19.5121301,0.737433779 C19.5121301,0.541850348 19.4340028,0.354277828 19.2949358,0.215981531 C19.1558688,0.0776852352 18.9672543,7.56090347e-15 18.7705868,7.56090347e-15 Z M5.92358682,1.47486756 L18.0290658,1.47486756 L18.0290658,11.1738105 C14.2973021,8.97309054 9.65535058,8.97309054 5.92358682,11.1738105 L5.92358682,1.47486756 Z M18.1007561,41.2595674 L5.99636711,41.4299146 L5.85981601,31.6542049 C9.57821205,33.8788456 14.2210294,33.9079466 17.9673268,31.7300942 L18.1007561,41.2595674 Z M18.5145248,29.5813449 C18.3213855,29.6276151 18.1558476,29.7507742 18.0566875,29.9219729 C14.6399048,32.3850192 10.0683918,32.5611966 6.47019098,30.3684944 C2.87199016,28.1757923 0.954202079,24.0451095 1.60955839,19.8992597 L11.7840648,22.6242176 C11.910502,22.657825 12.0435966,22.657825 12.1700339,22.6242176 L22.3430942,19.8992597 C22.928041,23.5784054 21.4627564,27.283944 18.51451,29.5813154 L18.5145248,29.5813449 Z M22.0285929,18.4557478 L11.9770678,21.1482955 L1.92411161,18.4556962 C3.24643275,14.0316721 7.33543291,10.9981285 11.9763466,10.9981285 C16.6172603,10.9981285 20.706247,14.0317105 22.0285929,18.4557404 L22.0285929,18.4557478 Z",
  id: "Shape",
  fill: "#AEAEAE"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#000000",
  fill: "#FFFFFF",
  cx: 11.9040105,
  cy: 21.2121224,
  r: 11.8461538
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#AEAEAE",
  x: 10.9783037,
  y: 16.3155819,
  width: 1.69230769,
  height: 5.64102564,
  rx: 0.846153846
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6910157,20.288736 C14.1482437,20.2917001 14.5180617,20.6618288 14.5206417,21.1190591 L14.5536974,26.9771319 C14.5562374,27.4272617 14.1933941,27.7942231 13.7432643,27.7967631 C13.7399701,27.7967817 13.7366759,27.7967803 13.7333817,27.7967589 C13.2761537,27.7937949 12.9063357,27.4236661 12.9037557,26.9664358 L12.8707,21.108363 C12.86816,20.6582332 13.2310033,20.2912718 13.6811331,20.2887318 C13.6844273,20.2887133 13.6877216,20.2887146 13.6910157,20.288736 Z",
  id: "Rectangle-Copy",
  fill: "#AEAEAE",
  transform: "translate(13.712199, 24.042747) rotate(-40.000000) translate(-13.712199, -24.042747) "
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#000000",
  x: 23.9526627,
  y: 18.9625247,
  width: 1.99605523,
  height: 4.99013807,
  rx: 0.998027613
}))));
function SvgWatchIconCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "44px",
    viewBox: "0 0 27 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3 Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchIconCase);
export default __webpack_public_path__ + "static/media/watch-icon-case.f1ad93e6a765c0e235cb1c40a4893ba4.svg";
export { ForwardRef as ReactComponent };